import { Albert_Sans } from "next/font/google";

export const albert = Albert_Sans({
  display: "swap",
  style: ["normal"],
  subsets: ["latin"],
  weight: ["400", "600", "700"],
  variable: "--font-albert",
  adjustFontFallback: false,
});

export const fonts = {
  albert,
};
